import type { ReactElement } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { App } from './App'
import { FogChessView } from './views/FogChessView'
import { LobbyView } from './views/LobbyView'
import { NotFoundView } from './views/NotFoundView'
import { FOG_CHESS_PATH } from './routes'

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <LobbyView /> },
      { path: FOG_CHESS_PATH.slice(1), element: <FogChessView /> },
      { path: '*', element: <NotFoundView /> },
    ],
  },
])

export function AppRouter(): ReactElement {
  return <RouterProvider router={router} />
}
